import React from 'react';

const HoursDetailsContext = React.createContext({
    hoursDetails: [],
    setHoursDetails: () => { }
})

export default HoursDetailsContext;